var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('div',[_vm._v(_vm._s(_vm.title))]),(_vm.showEdit)?_c('div',{staticClass:"icon-wrap",on:{"click":_vm.handleEdit}},[_c('svg-icon',{attrs:{"width":"18","height":"18","name":"edit-block"}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }